import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";

const STORAGE_KEY = "gradconnect_guest_preview";

const GuestPreviewContext = createContext(null);

function readStoredPreview() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data && data.active ? data : null;
  } catch {
    return null;
  }
}

export function GuestPreviewProvider({ children }) {
  const [guestPreview, setGuestPreviewState] = useState(readStoredPreview);

  const setGuestPreview = useCallback((data) => {
    setGuestPreviewState(data);
    if (data && data.active) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  const clearGuestPreview = useCallback(() => {
    setGuestPreviewState(null);
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem("gradconnect_guest_id");
    sessionStorage.removeItem("gradconnect_guest_research_interests");
  }, []);

  const value = useMemo(
    () => ({
      isGuestPreview: !!(guestPreview && guestPreview.active),
      guestId: guestPreview?.guestId ?? null,
      researchInterestsFromHome: guestPreview?.researchInterests ?? null,
      setGuestPreview,
      clearGuestPreview,
    }),
    [guestPreview, setGuestPreview, clearGuestPreview]
  );

  return (
    <GuestPreviewContext.Provider value={value}>
      {children}
    </GuestPreviewContext.Provider>
  );
}

export function useGuestPreview() {
  const ctx = useContext(GuestPreviewContext);
  if (!ctx) {
    throw new Error("useGuestPreview must be used within GuestPreviewProvider");
  }
  return ctx;
}
